import { Component, Mixins } from 'vue-property-decorator'
import AccountSettings from '@/mixins/accountSettings.mixin'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'

@Component
export default class MissingGaurdianPopup extends Mixins(
  AccountSettings,
  DeviceWidthCheckerMixin
) {}
